import {Box, Typography} from '@mui/material';
import {MessageCircle} from 'lucide-react';
import React from 'react';
import {useBrandTheme} from '../useBrandTheme';

interface ChatiwiLogoProps {
  variant: `light` | `dark`;
}

export const ChatiwiLogo: React.FC<ChatiwiLogoProps> = ({variant}) => {
  const theme = useBrandTheme();

  const isLight = variant === `light`;

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        gap: 1,
        userSelect: `none`,
      }}
    >
      <MessageCircle
        size={24}
        style={{
          color: isLight ? theme.custom.colors.ui.white : theme.palette.text.primary,
          fill: isLight ? theme.custom.colors.ui.white : theme.palette.text.primary,
        }}
      />
      <Typography
        sx={{
          fontSize: isLight ? `20px` : `32px`,
          fontWeight: 700,
          ...(isLight
            ? {
                color: theme.custom.colors.ui.white,
                textShadow: `0 1px 3px rgba(0, 0, 0, 0.3)`,
              }
            : {
                color: theme.palette.text.primary,
              }),
          fontFamily: `"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
          letterSpacing: isLight ? `-0.5px` : `-0.02em`,
          lineHeight: isLight ? 1.2 : 1.1,
        }}
      >
        Chatiwi
      </Typography>
    </Box>
  );
};
